module.exports = __webpack_public_path__ + "img/SEL2070G.f4c99c06.jpg";